<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode === 'nohomesmall' else mbfilters">
        {{zielText }}
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn tmpnorightborder w100 tmp-bottom-left" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <!-- <mat-icon fontIcon="timelapse"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="#7c7c7d"
                d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        <span multilang class="ellipsis w100">{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #homemodeMobile>
    <button class="tmpbtn tmpnorightborder bottomleftradius w100" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <!-- <mat-icon fontIcon="timelapse"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="#7c7c7d"
                d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        <span multilang class="ellipsis w100">{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn tmpnorightborder w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <!-- <mat-icon fontIcon="timelapse"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="#7c7c7d"
                d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        <span multilang>{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <span multilang style="font-size: 18px;font-weight: 600;color:#242526">Reisedauer</span>

                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">close</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <span multilang style="font-size: 18px;font-weight: 600;color:#242526">Reisedauer</span>

                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">close</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <div class="blue-cont">
            <span multilang style="font-size: 16px;font-weight: 500;color:#242526;">Wie viele Wochen planen Sie
                zu reisen?</span>
            <div class="wrap" style="margin-top:1rem;">
                <ng-container *ngFor="let item of section1">
                    <button class="item-body" [class.selected]="zielText==item.name" (click)="selectValue(item)">
                        <span multilang class="first-item-line">{{item.name}}</span>
                    </button>
                </ng-container>
            </div>
        </div>
        <div class="blue-cont">
            <span multilang style="font-size: 16px;font-weight: 500;color:#242526;">Wie viele Tage möchten Sie
                reisen?</span>
            <div class="input-wrap">
                <input type="number" placeholder="Min" min="1" max="99" [(ngModel)]="minDauer"
                    (ngModelChange)="maxDauer = (minDauer + 1)" class="searchinput">
                <input type="number" placeholder="Max" min="{{minDauer + 1}}" max="99" [(ngModel)]="maxDauer"
                    class="searchinput">
            </div>
            <div class="wrap">
                <ng-container *ngFor="let item of section2">
                    <button class="item-body" [class.selected]="currentItem==item" (click)="selectValue(item)">
                        <span multilang class="first-item-line">{{item.name}}</span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="selected()" multilang>{{'ÜBERNEHMEN' }}</button>
    </div>
</ng-template>